import { ReactNode } from "react";
import { MetaFilterConfigProvider } from "../model/meta-filter-config";
import { MetaFilterConfig } from "../model/types";
import { PrimaryControl } from "./meta-filter-primary-control";
import { OtherControl } from "./meta-filter-other-control";
import { Controls } from "./meta-filter-controls";
import { useFilter } from "../model/use-filter";

export function MetaFilter({
  children,
  ...config
}: MetaFilterConfig & { children: ReactNode }) {
  return (
    <MetaFilterConfigProvider config={config}>
      {children}
    </MetaFilterConfigProvider>
  );
}

MetaFilter.Primary = PrimaryControl;
MetaFilter.Other = OtherControl;
MetaFilter.Controls = Controls;
MetaFilter.useFilter = useFilter;
